var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex no-print",attrs:{"id":"banner_content"}},[_c('img',{attrs:{"src":require("../assets/flag_and_logo.png")}})])
}]

export { render, staticRenderFns }